import { Injectable } from '@angular/core';

import {
    PcvizAnnotationTool,
    PcvizAreaTool,
    PcvizBaseSceneView,
    PcvizBufferTool,
    PcvizBufferToolConstructor,
    PcvizDistanceTool,
    PcvizElevationTool,
    PcvizInformationTool,
    PcvizJobSiteMapView,
    PcvizJobSiteSceneView,
    PcvizLayerEditionTool,
    PcvizPaintTool,
    PcvizPointEditionTool,
    PcvizProject,
    PcvizProjectEditionTool,
    PcvizReferencePlanesTool,
    PcvizSaveViewTool,
    PcvizSceneView,
    PcvizScreenshotTool,
    PcvizSettingsTool,
    PcvizSidesTool,
    PcvizTools,
    PcvizViewer,
} from '@mirage-projects/cw-models';

@Injectable({ providedIn: 'root' })
export class ToolsPcvizService {
    getTools(): PcvizTools {
        return PointCloudViz.Tools;
    }

    createSettingsTool(): PcvizSettingsTool {
        const settingsTool = new PointCloudViz.Tools.SettingsTool();
        return settingsTool;
    }

    initializeSettingsTool(pcvizProject: PcvizProject | null): PcvizSettingsTool {
        const settingTool = this.createSettingsTool();
        settingTool.initializePropertySet();
        if (pcvizProject) {
            settingTool.setProject(pcvizProject);
        }
        return settingTool;
    }

    createInformationTool(view: PcvizBaseSceneView): PcvizInformationTool {
        const informationTool = new PointCloudViz.Tools.InformationTool(view);
        return informationTool;
    }

    createDistanceTool(viewer: PcvizViewer): PcvizDistanceTool {
        return new PointCloudViz.Tools.DistanceTool(viewer);
    }

    createAreaTool(viewer: PcvizViewer): PcvizAreaTool {
        return new PointCloudViz.Tools.AreaTool(viewer);
    }

    createElevationTool(viewer: PcvizViewer): PcvizElevationTool {
        return new PointCloudViz.Tools.ElevationTool(viewer);
    }

    createLayerEditionTool(view: PcvizSceneView): PcvizLayerEditionTool {
        return new PointCloudViz.Tools.LayerEditionTool(view);
    }

    createPointEditionTool(view: PcvizSceneView): PcvizPointEditionTool {
        return new PointCloudViz.Tools.PointEditionTool(view);
    }

    createAnnotationTool(view: PcvizSceneView): PcvizAnnotationTool {
        return new PointCloudViz.Tools.AnnotationTool(view);
    }

    getBufferTool(): PcvizBufferTool {
        return PointCloudViz.Tools.BufferTool as PcvizBufferTool;
    }

    createBufferTool(viewer: PcvizViewer): PcvizBufferTool {
        return new (PointCloudViz.Tools.BufferTool as PcvizBufferToolConstructor)(viewer);
    }

    createScreenshotTool(view: PcvizBaseSceneView): PcvizScreenshotTool {
        return new PointCloudViz.Tools.ScreenshotTool(view);
    }

    createSaveViewTool(view: PcvizSceneView): PcvizSaveViewTool {
        return new PointCloudViz.Tools.SaveViewTool(view);
    }

    createPaintTool(idDiv: string, width: number, height: number, img: string, defaultLabel: string): PcvizPaintTool {
        return new PointCloudViz.Tools.PaintTool(idDiv, width, height, img, defaultLabel);
    }

    createProjectEditionTool(): PcvizProjectEditionTool {
        return new PointCloudViz.Tools.ProjectEditionTool();
    }

    createReferencePlanesTool(view: PcvizSceneView): PcvizReferencePlanesTool {
        return new PointCloudViz.Tools.ReferencePlanesTool(view);
    }

    createSidesTool(view: PcvizJobSiteMapView | PcvizJobSiteSceneView): PcvizSidesTool {
        return new PointCloudViz.Tools.SidesTool(view);
    }
}
